export default (type, data, config, headers) => {
  return {
    chart: {
      type: type,
      margin: [3, 0, 3, 0],
    },
    plotOptions: {
      series: {
        tooltip: {
          enabled: config.showTooltip ? true : false,
        },
      },
      [type]: {
        negativeColor: config.negativeChartColor || '#DD495E',
      },
    },
    series: data.map((d, i) => {
      return {
        data: [parseFloat(typeof d === 'string' ? d.replace(/ /g, '').replace(/,/g, '.') : d)],
        pointStart: 1,
        name: headers[i],
      };
    }),
    colors: config.chartColors || [
      '#235A61',
      '#DD495E',
      '#2A2383',
      '#F2C60E',
      '#24CBE5',
      '#64E572',
      '#FF9655',
      '#FFF263',
      '#6AF9C4',
    ],
    tooltip: {
      headerFormat: '<b>' + config.columnName + '</b><br/>',
      pointFormat: '<b>{series.name}:</b> {point.y}<br/>',
    },
  };
};
